import React, { useState, useEffect } from "react";
import axios from "axios";
import Utils from "../../utils/utils";
import { useToast } from "../ToastContext";

import LoadingComp from "../LoadingComp";
import AssignmentCard from "./AssignmentCard";
import AssignmentViewStudent from "./AssignmentViewStudent";

const AssignmentDashboard = ({ user }) => {
  const token = Utils.getToken();
  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
  const showToast = useToast();
  const [assignments, setAssignments] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [renderAssignment, setRenderAssignment] = useState(false);
  const [showGuide, setShowGuide] = useState(false);

  const [editFormVisible, setEditFormVisible] = useState(false);

  const [assignmentToView, setAssignmentToView] = useState(null);
  const [indexOfItem, setIndexOfItem] = useState(null);

  const handleItemToView = (item, idx) => {
    setAssignmentToView(item);
    setIndexOfItem(idx);
    setEditFormVisible(true);
  };

  const closeAssignmentView = () => {
    setAssignmentToView(null);
    setIndexOfItem(null);
    setEditFormVisible(false);
  };

  const FetchAssignments = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/assignments/student`, {
        method: "GET",
        mode: "cors",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        setAssignments(response.data.data);
        setLoaded(true);
      } else {
        showToast(response.statusText, "error", true, 5000);
        return;
      }
    } catch (error) {
      // console.log("Catch => " + error.message);
      showToast(error.message, "error", true, 5000);
    }
  };

  useEffect(() => {
    FetchAssignments();
  }, []);

  useEffect(() => {
    setRenderAssignment(true); // Show the component with a slide-in effect
  }, []);

  if (!loaded) {
    return (
      <div className=" overflow-y-auto overflow-x-hidden space-y-4 h-[calc(100vh-65px)]">
        <LoadingComp message={"Loading Assignment"} />
      </div>
    );
  }

  return (
    <div className="shadow-none p-4 overflow-y-auto overflow-x-hidden space-y-4 h-[calc(100vh-65px)]">
      <div className="flex justify-between">
        {/* <div className="relative group ">

          <button
            onMouseEnter={() => setShowGuide(true)}
            className="absolute -top-1 right-0 btn btn-info  btn-sm py-2 text-white hover:font-semibold px-4 "
          >
            Help
          </button>

          {showGuide && (
            <div
              className="absolute bg-gradient-to-r z-50 from-gray-800 via-gray-900 to-black text-white px-6 py-5 rounded-lg shadow-xl top-0 right-1/2 -transform translate-x-[-10px] mt-10 mb-4 max-w-md w-full"
              onClick={() => setShowGuide(false)}
            >
              <h4 className="text-xl font-semibold mb-3 text-gray-100">
                Assignment Submission Guidelines
              </h4>
              <p className="text-sm text-gray-300 leading-relaxed">
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    You must submit the assignment before the due time. After
                    the deadline, submissions will be closed.
                  </li>
                  <li>
                    Each question has a maximum mark, which may be optional for
                    some questions.
                  </li>
                  <li>
                    For each question, you are required to provide a URL or
                    link.
                  </li>
                  <li>
                    If submitting a Google Drive link, ensure the access is set
                    to "Anyone with the link can view".
                  </li>
                  <li>
                    Once all URLs or links are submitted, click the "Submit"
                    button to finalize your assignment submission.
                  </li>
                </ul>
              </p>
            </div>
          )}
        </div> */}
      </div>

      <div className="w-full">
        {assignmentToView && (
          <AssignmentViewStudent
            props={{
              item: assignmentToView,
              index: indexOfItem,
              editFormVisible,
              closeAssignmentView,
              user,
            }}
          />
        )}

        {/* Overlay for the assignmetn edit */}
        {editFormVisible && (
          <div
            key={"OverLay" + assignmentToView}
            className="fixed cursor-not-allowed top-0 left-0 w-full h-[100%] z-40 bg-black bg-opacity-50"
            onClick={closeAssignmentView}
          ></div>
        )}
      </div>

      {loaded && assignments.length === 0 && (
        <LoadingComp message={"No assignment found"} loaded={true} />
      )}

      <div
        className={`w-[100%] transition-transform duration-700 ease-in-out transform ${
          renderAssignment
            ? "translate-x-0 opacity-100"
            : "translate-x-[-100%] opacity-0"
        } `}
        key="AssignmentCardContainer"
      >
        <div className="grid gap-6">
          {assignments.map((assignment, index) => (
            <AssignmentCard
              props={{ index, assignment, handleItemToView, user }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AssignmentDashboard;
